<script>
  
  let { 
    user, date, clinic, 
    presences = $bindable([]), absences = $bindable([]), 
    shownPresence = $bindable(null), shownAbsence = $bindable(null), 
    createPresence, createAbsence, deletePresence, deleteAbsence,
    absenceMode = false, halfDayMode = false, alerts = false, role = "viewer"
  } = $props();

  let creator = $derived(role === "admin" || (role === "manager" && !user.vet));
  let canSelectRecord = $derived(role === "admin" || role === "manager" || role === "viewer");

  const getStatus = (period) => {
    const presence = presences.find(p => p.period === period);
    const absence = absences.find(a => a.period === period);
    return { presence, absence };
  };

  const dayStatus = $derived(getStatus("day"));
  const amStatus = $derived(getStatus("am"));
  const pmStatus = $derived(getStatus("pm"));

  let actionColor = $derived(absenceMode ? "gray-800" : user.color);
  let emptyCell = $derived(!presences.length && !absences.length);
  
  let presenceClasses = $derived(`text-xxs text-white flex items-center justify-center h-full w-full ${canSelectRecord ? 'cursor-pointer' : 'cursor-default'}`);
  
  const buttonClasses = (status, text) => {
    if (status.presence) {
      const external = status.presence.clinic.id !== clinic.id;
      return `text-xxs text-white ${external ? 'bg-gray-600 italic' : `bg-${user.color}`} flex items-center justify-center h-full w-full ${canSelectRecord ? 'cursor-pointer' : 'cursor-default'}`;
    }
    if (status.absence) return `text-xxs text-white bg-gray-800 flex items-center justify-center h-full w-full ${canSelectRecord ? 'cursor-pointer' : 'cursor-default'}`;
    return `text-xxs text-white flex items-center justify-center h-full w-full ${creator ? `hover:bg-${actionColor}/70 cursor-pointer` : 'cursor-default'}`;
  };

  function handleClick(period, status) {
    if (status.presence) return showPresence(status.presence);
    if (status.absence) return showAbsence(status.absence);
    if (!creator) return;
    if (absenceMode) return addAbsence(period);
    return addPresence(period);
  };

  function addPresence(period) {
    const params = { user: user.id, date: date, clinic: clinic.id, period: period };
    createPresence(params)
  }

  function addAbsence(period) {
    const params = { user: user.id, date: date, period: period };
    createAbsence(params)
  }

  function showPresence(presence) {
    shownPresence = presence;
  }

  function showAbsence(absence) {
    shownAbsence = absence;
  }

  function handleDelete(status) {
    status.presence ? deletePresence(status.presence.id) : deleteAbsence(status.absence.id);
  }

</script>

{#snippet deleteButton(status)}
  {@const disabled = status.presence && !status.presence.deletable}
  {#if creator}
    <div class="absolute top-2 right-2 flex gap-2 opacity-0 group-hover:opacity-100">
      <button type="button" {disabled} onclick={() => handleDelete(status)} class="text-gray-50 hover:text-white text-xs transition-colors" aria-label="Supprimer la présence/absence">
        <i class="fal fa-trash-alt"></i>
      </button>
    </div>
  {/if}
{/snippet}

<!-- Main calendar slot container -->
<div class="presence-cell relative">

  {#if emptyCell && !halfDayMode}
    
  <!-- Full day slot when empty -->
    <div class="absolute inset-0 w-full h-full group">
      <button type="button" class={`w-full ${buttonClasses(dayStatus, "Jour")}`} onclick={() => handleClick("day", dayStatus)}>Jour</button>
    </div>
  
  {:else if dayStatus.presence}
    
    {@const external = dayStatus.presence.clinic.id !== clinic.id}
    {@const text = external ? dayStatus.presence.clinic.name : 'Jour'}
    
    <!-- Full day slot with presence -->
    <div class="absolute inset-0 w-full h-full group">
      
      <button type="button" class={`w-full ${presenceClasses} ${external ? 'bg-gray-600 italic' : `bg-${user.color}`}`} onclick={() => handleClick("day", dayStatus)}>
        <span>{text}</span>
        {#if dayStatus.presence.notes?.length > 0}
          <span class="text-xs ml-[2px]">*</span>
        {/if}
      </button>

      {@render deleteButton(dayStatus)}
    </div>

  {:else if dayStatus.absence}

    <!-- Full day slot with absence -->
    <div class="absolute inset-0 w-full h-full group">
      <button type="button" class={`w-full ${buttonClasses(dayStatus, "Absent")}`} onclick={() => handleClick("day", dayStatus)}>{dayStatus.absence.reason || "Absent"}</button>
      {@render deleteButton(dayStatus)}
    </div>
  
  {:else}
  
  <!-- Split day slots (AM/PM) -->

    <!-- AM slot -->
    <div class="absolute inset-0 left-0 w-1/2 h-full group">
      <button type="button" class={buttonClasses(amStatus, "Matin")} onclick={() => handleClick("am", amStatus)}>
        {#if amStatus.presence}
          {@const external = amStatus.presence.clinic.id !== clinic.id}
          {external ? amStatus.presence.clinic.name : `Matin${amStatus.presence.notes?.length > 0 ? ' *' : ''}`}
        {:else if amStatus.absence}
          {amStatus.absence.reason || "Absent"}
        {:else}
          Matin
        {/if}
      </button>
      {#if amStatus.presence || amStatus.absence}
      {@render deleteButton(amStatus)}
      {/if}
    </div>

    <!-- PM slot -->
    <div class="absolute inset-0 left-1/2 w-1/2 h-full group">
      <button type="button" class={buttonClasses(pmStatus, "Après-midi")} onclick={() => handleClick("pm", pmStatus)}>
        {#if pmStatus.presence}
          {@const external = pmStatus.presence.clinic.id !== clinic.id}
          {external ? pmStatus.presence.clinic.name : `Après-midi${pmStatus.presence.notes?.length > 0 ? ' *' : ''}`}
        {:else if pmStatus.absence}
          {pmStatus.absence.reason || "Absent"}
        {:else}
          Après-midi
        {/if}
      </button>
      {#if pmStatus.presence || pmStatus.absence}
        {@render deleteButton(pmStatus)}
      {/if}
    </div>

  {/if}
</div>
